export default __webpack_public_path__ + "static/media/condenser.3d50ba10.png";